import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function usePageTracker() {
  const location = useLocation();

  useEffect(() => {
    const track = async () => {
      try {
        await fetch(`${API}/track`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ path: location.pathname, referrer: document.referrer }),
        });
      } catch {}
    };
    track();
  }, [location.pathname]);
}
